import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../../utilities/appFetch';
import clientRoutes from '../../../components/client/clientRoutes';

const update = createAsyncThunk(
  'thunk/client/delete',
  async (arg, thunkAPI) => {
    const response = await apiFetch(clientRoutes.api.generate.delete(arg?.id), {
      method: 'DELETE',
    });
    if (!response?.success) {
      return thunkAPI.rejectWithValue(response);
    }
    return response.result;
  },
);

export default update;
